import styled from '@emotion/styled';

import { Button } from '@/components/common/Buttons';
import { Divider } from '@/components/common/Divider';
import { Title } from '@/components/common/Title';
import { PortableText } from '@/components/common/utils';
import { Stack } from '@/components/layout/Stack';
import { subheadingSmall } from '@/styles/typography';

import type { CaseStudyType } from '@/types/shared';

export interface CaseStudyHeroProps {
  heading: CaseStudyType['heading'];
  description?: CaseStudyType['description'];
}

export const CaseStudyHero = ({ heading, description }) => {
  return (
    <Stack spacing="--space-block-md">
      <Button
        variant="text-light"
        icon="ArrowLeft"
        iconPosition="left"
        size="md"
        href="/case-studies"
      >
        All case studies
      </Button>
      <TextWrapper>
        <Title variant="hero" size="sm" heading={heading} />
        {!!description && <PortableText value={description} />}
      </TextWrapper>
      <Divider orientation={{ base: 'none', lg: 'horizontal' }} />
    </Stack>
  );
};

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-component-xl);

  p {
    ${subheadingSmall}
    color: var(--text-warm-base);
  }
`;
